import Button from 'cc/Button'
import toast from 'react-hot-toast'
import { useClipboard } from 'use-clipboard-copy'

const CopyToClipboard = ({ label, desc, value }) => {
  const clipboard = useClipboard({
    onSuccess() {
      toast.success(
        <span>
          Copied{desc ? ` ${desc}` : ''} to clipboard:{' '}
          <span className="text-xs text-gray-500 text-monospace break-all">{value}</span>
        </span>,
      )
    },
    onError() {
      toast.error('Browser is not cooperating - please copy text manually')
    },
  })

  return (
    <div className="text-center">
      <input ref={clipboard.target} value={value} className="hidden" readOnly />
      <Button onClick={clipboard.copy} variant="secondary">
        {label}
      </Button>
    </div>
  )
}

export default CopyToClipboard
